import './Header-493b1d76.css';

var classes = {"Header":"prc-ActionList-Header-tbTgu"};

export { classes as default };
